<template>
  <div class="login-wrapper">
    <div class="bg-image"></div>

    <div class="container">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-md-6 col-lg-4">
          
          <div class="glass-card">
            <div class="text-center mb-4">
              <h4 class="text-white">Vertical Innovations Ltd.</h4>
              <p class="text-light-50">Agent Portal Login</p>
            </div>

            <div v-if="incorrectAuth" class="alert alert-danger py-2 text-center shadow-sm">
              <small>Incorrect Email or Password!</small>
            </div>

            <form @submit.prevent="login">
              <div class="form-group mb-3">
                <label for="username" class="input-label">Email</label>
                <input 
                  type="text" 
                  class="form-control glass-input" 
                  v-model="email" 
                  placeholder="your-email@gmail.com" 
                  id="username"
                >
              </div>
              
              <div class="form-group mb-4">
                <label class="input-label">Password</label>
                <div class="input-group">
                  <input 
                    :type="showPassword ? 'text' : 'password'" 
                    v-model="password" 
                    class="form-control glass-input border-right-0" 
                    placeholder="Enter password" 
                    required
                  >
                  
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer glass-addon" @click="togglePasswordVisibility">
                      <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </span>
                  </div>
                </div>
              </div>

              <input type="submit" value="Log In" class="btn btn-primary btn-block shadow-sm">
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'Login_A',
    data () {
        return {
            email: '',
            password: '',
            showPassword: false,
            incorrectAuth: false
        }
    },
    methods : {
      togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
      },
      login() {
        const payload = {
          email: this.email,
          password: this.password
        }
        
        this.$store.dispatch('userLogin', payload)
        .then(response => {
            if (response && response.hasPunchedIn === false) {
                this.$router.push({ name: 'attendance' })
            } else {
                this.$router.push({ name: 'posts' })
            }
        })
        .catch(err => {
          console.log(err)
          this.incorrectAuth = true
        })
      }
    }
}
</script>

<style scoped>
/* 1. Main Wrapper */
.login-wrapper {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 2. Background Image */
.bg-image {
  position: absolute;
  top: -5px; left: -5px; right: -5px; bottom: -5px;
  background-image: url('images/backdrop.png');
  background-size: 100% 100%;
  background-position: center;
  filter: blur(5px); 
  z-index: 0; 
}

.container {
  position: relative;
  z-index: 10;
}

/* 3. Glass Card */
.glass-card {
  padding: 40px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2); 
  backdrop-filter: blur(15px);          
  -webkit-backdrop-filter: blur(15px);  
  border: 1px solid rgba(255, 255, 255, 0.3); 
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

h3.text-white, h4.text-white {
  color: #fff;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.text-light-50 {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 300;
}

.input-label {
  color: #fff;
  font-weight: 500;
  margin-bottom: 5px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* 4. Glass Inputs Styling */
.glass-input {
  background: rgba(255, 255, 255, 0.4); 
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff; 
  height: 50px;
  /* Only round left corners for password input to connect with icon */
  transition: all 0.3s ease;
}

.glass-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* 5. The "Eye" Icon Styling (Glass Addon) */
.glass-addon {
  background: rgba(255, 255, 255, 0.4); /* Match input bg */
  border: 1px solid rgba(255, 255, 255, 0.2); /* Match input border */
  border-left: none; /* Remove divider between input and icon */
  color: #fff; /* White Icon */
  height: 50px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

/* 6. FOCUS STATE LOGIC (Critical) */
/* When input is focused... */
.glass-input:focus {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  box-shadow: none; /* Remove bootstrap glow, we handle border */
  border-color: #fff;
}
.glass-input:focus::placeholder {
    color: #999;
}

/* ...The Eye Icon must also change to match the focused input */
.glass-input:focus + .input-group-append .glass-addon {
  background: rgba(255, 255, 255, 0.9);
  border-color: #fff;
  border-left: none;
  color: #333; /* Dark Icon */
}

/* Helper to remove right border of password input */
.border-right-0 {
    border-right: none !important;
}

/* Button Styling */
.btn-primary {
  background-color: #90288b;
  border: none;
  height: 50px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: transform 0.2s;
}

.btn-primary:hover {
  background-color: #d8a4d5;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(251, 119, 26, 0.4);
}

.alert-danger {
  background: rgba(220, 53, 69, 0.8);
  border: none;
  color: white;
}

.cursor-pointer {
  cursor: pointer;
}
</style>